import React, { useEffect, useState, useMemo } from "react";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import { URL_BASE } from "../../config/url-server";
import { Divider, Spin, Modal } from "antd";
import config from "../../config/config"; // Aquí debe estar tu token de Mapbox
import { Link } from "react-router-dom";
import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import reportServices from "../../services/report-services";

import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";

import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";

import moment from "moment";

import { useForm } from "react-hook-form";

const HealthIncidentsMap = () => {

    const [title, setTitle] = useState("Finca - Lote");

    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    const VIBRANT_COLORS = [
        "#E41A1C", // Rojo
        "#377EB8", // Azul
        "#4DAF4A", // Verde
        "#984EA3", // Púrpura
        "#FF7F00", // Naranja
        "#FFFF33", // Amarillo
        "#A65628", // Marrón
        "#F781BF", // Rosa
        "#999999", // Gris
        "#66C2A5", // Verde azulado
        "#FC8D62", // Naranja claro
        "#8DA0CB", // Azul claro
        "#E78AC3", // Rosa claro
        "#A6D854", // Verde lima
        "#FFD92F", // Amarillo claro
    ];



    const [lotId, setLotId] = useState("0");
    const [farmId, setFarmId] = useState("0");
    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup
    const [lotPalmsLayer, setLotPalmsLayer] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const [markerData, setMarkerData] = useState([]);
    const [popupInfo, setPopupInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [palmMovements, setPalmMovements] = useState([]);
    const [loadingMovements, setLoadingMovements] = useState(false);
    const [lotPolygons, setLotPolygons] = useState([]);


    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");





    registerLocale("es", es);
    const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
    const end_date = moment().endOf("day").toDate();
    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);

    const [lotPalms, setLotPalms] = useState([]); // Puntos de todas las palmas del lote    
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [listUsers, setListUsers] = useState(escoja);



    const listType = [
        { _id: "0", name: "TODO" },
        { _id: "Enfermedad", name: "Enfermedad" },
        { _id: "Plaga", name: "Plaga" },
        { _id: "Anomalia", name: "Anomalia" }
    ]



    const {
        register,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();










    const getFarmLotPolygons = async (farmId) => {
        if (!farmId || farmId === "0") {
            setLotPolygons([]);
            return;
        }
        try {
            const params = {
                farmId
            };
            const configRequest = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                },
                params
            };
            const response = await axios.get(
                URL_BASE + "map/get-farm-polygons",
                configRequest
            );
            const polygons = response?.data?.data || [];
            setLotPolygons(polygons);
        } catch (error) {
            console.error(
                "Error obteniendo polígonos de los lotes:",
                error
            );
            setLotPolygons([]);
        }
    };


    const lotPolygonsGeoJson = useMemo(() => {

        return {
            type: "FeatureCollection",

            features: lotPolygons
                .filter(lot =>
                    lot.lotPolygon?.type === "Polygon" &&
                    lot.lotPolygon?.coordinates?.length > 0
                )
                .map((lot, index) => {

                    return {
                        type: "Feature",

                        geometry: {
                            type: "Polygon",
                            coordinates: lot.lotPolygon.coordinates
                        },

                        properties: {
                            id: lot._id,
                            name: lot.name,
                            lotCode: lot.lotCode,
                            color: VIBRANT_COLORS[1]
                        }
                    };
                })
        };

    }, [lotPolygons]);


    const lotPolygonsLayer = lotPolygons.length > 0 ? (
        <Source
            id="lot-polygons"
            type="geojson"
            data={lotPolygonsGeoJson}
        >
            <Layer
                id="lot-polygons-fill"
                type="fill"
                paint={{
                    "fill-color": ["get", "color"],
                    "fill-opacity": 0.3
                }}
            />

            <Layer
                id="lot-polygons-line"
                type="line"
                paint={{
                    "line-color": ["get", "color"],
                    "line-width": 2,
                    "line-opacity": 0.9,
                    "line-dasharray": [3, 2]
                }}
            />

            <Layer
                id="lot-polygons-label"
                type="symbol"
                layout={{
                    "text-field": ["get", "name"],
                    "text-size": 12,
                    "text-allow-overlap": true
                }}
                paint={{
                    "text-color": "#FFFFFF",
                    "text-halo-color": "#000000",
                    "text-halo-width": 2
                }}
            />
        </Source>
    ) : null;






    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
                //setValue("farm",0)
            }
        }
    };




    const getListSection = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")

            setFarmId(code);
            await getFarmLotPolygons(code);

            return;
        }
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }


        setFarmId(code);
        await getFarmLotPolygons(code);
    };



    const getLisLots = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };










    const loadPalmMovements = async () => {
        try {
            setLoadingMovements(true);

            console.log("selectedPoint::::", selectedPoint)

            const start = moment(startDate).startOf("day").format('YYYY-MM-DD');
            const end = moment(endDate).endOf("day").format('YYYY-MM-DD');
            const palmId = selectedPoint.palmId
            const params = { startDate: start, endDate: end, palmId }
            const response = await reportServices.healthDetailedReportByPalm(params);


            setPalmMovements(response.data);
            setModalVisible(true);

        } catch (error) {
            toast.error("Error cargando movimientos");
        } finally {
            setLoadingMovements(false);
        }
    };



    const generateExcel = async () => {

        const lotId = getValues("lot");


        /*if (lotId == "0") {
            toast.error("Debe seleccionar un lote!", { autoClose: 1800 })
            return
        }*/

        const type = getValues("type");
        const farmId = getValues("farm");
        const optionId = getValues("option");
        const sectionId = getValues("section");
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
        const userId = "0"


        setLoading(true);
        try {

            //(startDate, endDate,farmId,sectionId,lotId,userId,lineId,endPoint)
            const lineId = "0"
            const response = await reportServices.generateHealthExcel(start, end, farmId, sectionId, lotId, userId, lineId, "fruit-incidents-excel", type);

            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }


            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Cantidad de novedades de sanidad.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }











    const loadLotPositions = async () => {
        try {
            const lotId = getValues("lot");


            /*if (lotId == "0") {
                toast.error("Debe seleccionar un lote!", { autoClose: 1800 })
                return
            }*/

            const farmId = getValues("farm");
            const optionId = getValues("option");
            const sectionId = getValues("section");
            let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
            let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
            const userId = "0"
            const type = getValues("type")

            const params = { farmId, sectionId, lotId, startDate: start, endDate: end, userId, type };
            const configAxios = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            };

            const response = await axios.get(URL_BASE + "map/health-movement-map", configAxios);
            const palms = response.data.data;

            if (palms.length > 0) {
                const middle = Math.floor(palms.length / 2);
                const coords = palms[middle]?.location?.coordinates;

                if (coords && coords.length === 2) {
                    const lat = coords[1];
                    const lng = coords[0];
                    setCenterMap({ lat, lng });

                    setViewState({
                        latitude: lat,
                        longitude: lng,
                        zoom: 18,
                    });
                }


            }

            setMarkerData(palms);





            const filterCoord = palms.map((location, index) => {
                const [lng, lat] = location.location.coordinates;

                const value = location.quantity;
                const name = `${value}`;

                // Determinar el color según el valor
                let backgroundColor = "white";
                let colorLabel = "#000";
                if (value >= 1 && value <= 3) {
                    backgroundColor = "#FFEFBF"; // Amarillo claro
                } else if (value >= 3 && value <= 7) {
                    backgroundColor = "#FFD24D";
                } else if (value > 7) {
                    backgroundColor = "#FF4D4D";
                    colorLabel = "#000";
                }

                return (
                    <Marker
                        key={`lot-palm-${index}`}
                        longitude={lng}
                        latitude={lat}
                        anchor="center"
                    >
                        <div
                            onClick={() => setSelectedPoint(location)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: backgroundColor,
                                border: `2px solid #000`,
                                padding: "2px 4px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                width: "30px",
                                fontSize: "14px",
                                color: colorLabel,
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                            }}
                            title={name}
                        >
                            {name}
                        </div>
                    </Marker>
                );
            });




            setLotPalmsLayer(filterCoord)





        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        } finally {
            setLoading(false);
        }
    };


    const isValidCoordinate = (coord) => {


        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            !isNaN(coord[0]) &&
            !isNaN(coord[1])
        );
    };





    useEffect(() => {
        const farm_name = localStorage.getItem("farmName");
        const lot_name = localStorage.getItem("lotName");
        setTitle(`FINCA ${farm_name} - ${lot_name}`);
        getLisFarm();
        // loadLotPositions();
    }, []);




    useEffect(() => {

        if (!lotPolygonsGeoJson?.features?.length) {
            return;
        }

        const coordinates = [];

        lotPolygonsGeoJson.features.forEach(feature => {

            const rings = feature.geometry.coordinates;

            rings.forEach(ring => {

                ring.forEach(([lng, lat]) => {

                    coordinates.push([lng, lat]);

                });

            });

        });

        if (coordinates.length === 0) {
            return;
        }

        let minLng = coordinates[0][0];
        let maxLng = coordinates[0][0];
        let minLat = coordinates[0][1];
        let maxLat = coordinates[0][1];

        coordinates.forEach(([lng, lat]) => {

            minLng = Math.min(minLng, lng);
            maxLng = Math.max(maxLng, lng);

            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);

        });

        const centerLng = (minLng + maxLng) / 2;
        const centerLat = (minLat + maxLat) / 2;

        setViewState(prev => ({
            ...prev,
            longitude: centerLng,
            latitude: centerLat,
            zoom: 15
        }));

    }, [lotPolygonsGeoJson]);




    return (
        <div >

            <ToastContainer />
            <Modal
                title={`Novedades Línea ${selectedPoint?.lineName} Palma ${selectedPoint?.palmName}`}
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={800}
            >
                <Spin spinning={loadingMovements}>
                    <table className="table table-bordered">
                        <thead>
                            <tr className="table-primary">
                                <th>Fecha</th>
                                <th>Tipo</th>
                                <th>Novedad</th>
                                <th>Cantidad</th>
                                <th>Acción</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {palmMovements.length === 0 ? (
                                <p>Sin registros</p>
                            ) : (
                                palmMovements.map((mov, index) => (
                                    <tr>
                                        <td>{moment(mov.date).format("YYYY-MM-DD")}</td>
                                        <td>{mov.issueType}</td>
                                        <td>{mov.issueName}</td>
                                        <td>{mov.quantity}</td>
                                        <td>{mov.actionTaken}</td>
                                        <td>{mov.result}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </Spin>
            </Modal>





            <div className="row">


                <div className="col-12 col-sm-2">

                    <div className="col-12 ml-4 ms-2" style={{ marginTop: "-10px" }}>
                        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Novedades Sanidad</Divider>
                    </div>

                    <form className="form-react">
                        <div className="row ms-2">




                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Finca</label>
                                <select
                                    className="form-control text-secondary"

                                    {...register("farm")}
                                    onChange={(e) => getListSection(e)}
                                >
                                    {listFarms.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="  col-12 col-sm-12 mt-1">
                                <label className="text-secondary fw-bold">Sección</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("section")}
                                    {...register("section")}
                                    onChange={(e) => getLisLots(e)}
                                >
                                    {listSection.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className=" col-12 mt-1">
                                <label className="text-secondary fw-bold">Lote</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("lot")}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setLotId(value);
                                    }}
                                >
                                    {listLots.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>



                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Desde</label>
                                <br />
                                <DatePicker
                                    {...register("startDate")}
                                    locale="es"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control text-secondary"
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                />
                            </div>

                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Hasta</label>
                                <br />
                                <DatePicker
                                    {...register("endDate")}
                                    locale="es"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control 
                                      text-secondary"
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                />
                            </div>




                            <div className=" col-12 mt-1">
                                <label className="text-secondary fw-bold">Categoria</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("type")}
                                >
                                    {listType.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className=" col-12">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-primary w-100"
                                        type="button"
                                        onClick={() => loadLotPositions()}
                                    >
                                        <i className="bi bi-search fa-lg m-2" /> Buscar
                                    </button>

                                </Spin>

                            </div>


                            <div className=" col-12 mb-4">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-info w-100"
                                        type="button"
                                        onClick={() => generateExcel()}
                                    >
                                        <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                                    </button>
                                </Spin>
                            </div>




                        </div>
                    </form>





                    <div className="col-12 m-3">



                        <h6 style={{ fontWeight: "bold", marginBottom: "8px" }}>Leyenda de colores</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#FFEFBF", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>1 a 3 Novedades</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#FFD24D", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>3 a 7 Novedades</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#D90000", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>Más de 7 novedades</span>
                            </div>
                        </div>

                    </div>




                </div>



                <div className="col-12 col-sm-10">
                    <Map
                        {...viewState} // Aplicar el estado de la vista dinámica
                        onMove={evt => setViewState(evt.viewState)} // Permitir mover el mapa
                        style={{ width: "100%", height: "100vh" }}
                        mapStyle="mapbox://styles/mapbox/satellite-v9" // Mapa satelital
                        mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                    >

                        <NavigationControl position="top-left" />



                        {lotPolygonsLayer}

                        {lotPalmsLayer}

                        {selectedPoint && selectedPoint.location?.coordinates && (
                            <Popup
    longitude={selectedPoint.location.coordinates[0]}
    latitude={selectedPoint.location.coordinates[1]}
    onClose={() => setSelectedPoint(null)}
    closeOnClick={false}
    maxWidth="500px"
>
    <div style={{ minWidth: "400px" }}>

        <p className="text-success mb-2">
            <strong>
                Línea: {selectedPoint.lineName} - Palma {selectedPoint.palmName}
            </strong>
        </p>

        <hr />

        <strong>Novedades registradas:</strong>

        {/* CONTENEDOR CON SCROLL */}
        <div
            style={{
                maxHeight: "250px",
                overflowY: "auto",
                marginTop: "10px",
                paddingRight: "5px"
            }}
        >

            {selectedPoint.healthMovements?.length > 0 ? (

                selectedPoint.healthMovements.map((movement, index) => (

                    <div
                        key={index}
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "8px",
                            marginBottom: "8px",
                            backgroundColor: "#f8f9fa"
                        }}
                    >
                        <div>
                            <strong>Novedad:</strong>{" "}
                            {movement.issueName}
                        </div>

                        <div>
                            <strong>Tipo:</strong>{" "}
                            {movement.issueType}
                        </div>

                        <div>
                            <strong>Cantidad:</strong>{" "}
                            {movement.quantity}
                        </div>

                        <div>
                            <strong>Acción:</strong>{" "}
                            {movement.actionTaken || "N/A"}
                        </div>

                        <div>
                            <strong>Resultado:</strong>{" "}
                            {movement.result || "N/A"}
                        </div>

                        <div>
                            <strong>Usuario:</strong>{" "}
                            {movement.userName}
                        </div>

                        <div>
                            <strong>Fecha:</strong>{" "}
                            {moment(movement.date).format("YYYY-MM-DD HH:mm")}
                        </div>

                    </div>

                ))

            ) : (
                <p className="text-muted mt-2">
                    No hay novedades registradas.
                </p>
            )}

        </div>

    </div>
</Popup>
                        )}


                    </Map>

                </div>



            </div>




        </div>
    );
};

export default HealthIncidentsMap;
